export default "__VITE_ASSET__CSfd_64f__"